<template>
    <v-card class="welcome-card overflow-hidden" :height="height">
        <v-card-text>
            <p class="card-title">
                <KpIcon icon-cls="confetti" color="black" /> {{ $t('welcome') }}, {{ user.firstname }}
                {{ user.lastname }}
            </p>
            <p v-html="$t('welcome_text')"></p>
            <p>
                <v-menu offset-y>
                    <template #activator="{ on, attrs }">
                        <v-btn depressed small color="white primary--text" v-bind="attrs" v-on="on">
                            {{ $t('neu_event') }}
                            <KpIcon icon-cls="arrowdown" color="primary" disabled-color="grey" right />
                        </v-btn>
                    </template>
                    <EventNewMenu />
                </v-menu>
            </p>
        </v-card-text>
    </v-card>
</template>

<script>
import { User } from '@/models/User';
import dayjs from 'dayjs';
import EventNewMenu from '../event/NewMenu.vue';

export default {
    name: 'WelcomeCard',
    components: { EventNewMenu },
    props: {
        user: {
            type: User,
            required: true,
        },
        height: {
            type: [String, Number],
            default: null,
        },
    },
    data() {
        return {
            today: dayjs(),
        };
    },
};
</script>

<style lang="scss" scoped>
.welcome-card {
    p {
        max-width: 350px;
        font-size: 1rem;
        color: var(--gray-text-color);
        &.card-title {
            color: var(--nearblack-color);
        }
    }
    background-image: url('~@/assets/minasa-dashboard-box-2.1.png');
    background-repeat: no-repeat;
    background-position-x: right;
    background-size: cover;
}
</style>
